enum Tag {
    React       = 'React',
    ReactNative = 'React Native',
    Expo        = 'Expo',
    Javascript  = 'Javascript',
    Typescript  = 'Typescript',
    Apex        = 'Apex',
    Flow        = 'Flow',
    Salesforce  = 'Salesforce',
    CSS         = 'CSS',
    HTML        = 'HTML',
    LWC         = 'LWC',
    Visualforce = 'Visualforce',
    Java        = 'Java',
    VSCode      = 'VSCode',
    Bootstrap   = 'Bootstrap',
    AzureDevOps = 'Azure DevOps',
    Wrike       = 'Wrike',
    RESTApi     = 'REST APIs',
    Agile       = 'Agile',
    XML         = 'XML',
    JSON        = 'JSON',
    SQLite         = 'SQLite'
}
export default Tag;